<template>
  <div class="comments">
    <template v-if="comments.length">
      <hr>
      <h2 class="comments-box-title mt-5">
        {{ i18n.t('petitions.comments.index.text') }}
      </h2>
      <ul class="comments-box list-unstyled mt30">
        <li v-for="comment in comments" :key="comment.id">
          <comment :id="comment.id"
                   :awaiting-approval="comment.awaitingApproval"
                   :commenter-display-name="comment.commenterDisplayName"
                   :created-at="comment.createdAt"
                   :petition-slug="petitionSlug"
                   :text="comment.text" />
        </li>
      </ul>
      <div v-if="nextPage" class="d-flex justify-content-end">
        <link-button class="small-text" @click="fetchMoreComments">
          {{ i18n.t('buttons.read_more') }}
        </link-button>
      </div>
    </template>
  </div>
</template>

<script>
import Comment from './comment'
import LinkButton from '@/components/buttons/link-button'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  components: { Comment, LinkButton },

  props: {
    initialComments: {
      type: Array,
      required: true
    },
    moreComments: {
      type: Boolean,
      required: true
    },
    petitionSlug: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState('comments', ['comments', 'nextPage'])
  },

  mounted() {
    this.setPetitionSlug(this.petitionSlug)
    this.initializeComments({comments: this.initialComments, currentPage: 1, nextPage: this.moreComments ? 2 : null})
  },

  methods: {
    ...mapActions('comments', ['fetchNextPageOfComments']),
    ...mapMutations('comments', ['initializeComments', 'setPetitionSlug']),
    fetchMoreComments() {
      this.fetchNextPageOfComments(this.petitionSlug)
    }
  }
}
</script>
